import React from 'react';

const ContextComponents = React.createContext();

export default ContextComponents;
